// API action type identifiers used to item requests for deduplication and tracking.

// job API
export const START_PUT_JOB_API = 'start_put_job_api';
export const START_PUT_JOB_API_DUPLICATE_PARENT_KEY = 'start_put_job_api_duplicate_parent_key';
export const START_UPDATE_JOBS = 'start_update_jobs';

// place API
export const START_POST_PLACE_API = 'start_post_place_api';
export const END_PUT_PLACE_API = 'end_put_place_api';

export const START_POST_DESTINATION = 'start_post_destination';
export const START_PUT_DESTINATION = 'start_put_destination';
export const START_POST_ORIGIN = 'start_post_origin';
export const START_PUT_ORIGIN = 'start_put_origin';

export const START_POST_STOP = 'start_post_stop';
export const START_PUT_STOP = 'start_put_stop';
export const START_DELETE_STOP = 'start_delete_stop';

// utils
export const SILENT_ERROR = 'silent_error';
